<template>
  <el-dropdown class="swt-org-container" @command="handleCommand">
    <span class="el-dropdown-link">
      {{currentAccount.companyName}}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <div v-for="account of accounts" :key="account.eid">
        <el-dropdown-item :command="account" divided>{{account.companyName}}</el-dropdown-item>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'HeaderSwtOrg',
  computed: {
    ...mapState(['currentAccount', 'accounts'])
  },
  methods: {
    ...mapActions({
      switchAccount: 'switchAccountAction'
    }),
    handleCommand (account) {
      if (this.currentAccount.eId !== account.eId) {
        this.$confirm('Please make sure to have saved all the work properly', {
          confirmButtonText: 'Sure',
          cancelButtonText: 'Cancel'
        }).then(() => {
          this.switchAccount(account)
          location.reload()
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.swt-org-container {
  margin: 0 10px;
}
.el-dropdown-link {
  cursor: pointer;
  font-size: 14px;
  color: white;
  font-weight: bold;
}
.el-dropdown-menu {
  padding: 4px 0;
}
.el-dropdown-menu__item {
  font-weight: bold;
}
.el-icon-arrow-down {
  font-size: 14px;
  color: white;
  font-weight: bold;
}
.el-divider {
  margin: 4px 0;
}
</style>
